import React, { useState } from "react";
import { FiGithub, FiLinkedin, FiMail, FiSend } from "react-icons/fi";

function ContactTransmission() {
  const [sent, setSent] = useState(false);

  const submit = (event) => {
    event.preventDefault();
    setSent(true);
  };

  return (
    <section className="ops-section" id="contact">
      <div className="section-heading">
        <p>Secure Transmission</p>
        <h2>Send Secure Transmission</h2>
      </div>
      <div className="contact-grid">
        <form className="contact-form glass-panel" onSubmit={submit}>
          <label>
            Name
            <input required type="text" name="name" autoComplete="name" />
          </label>
          <label>
            Email
            <input required type="email" name="email" autoComplete="email" />
          </label>
          <label>
            Reason for contact
            <select name="reason" defaultValue="Opportunity">
              <option>Opportunity</option>
              <option>Project collaboration</option>
              <option>Technical question</option>
              <option>General contact</option>
            </select>
          </label>
          <label>
            Message
            <textarea required name="message" rows="5" />
          </label>
          <button type="submit"><FiSend /> Send Transmission</button>
          {sent && (
            <p className="transmission-sent" role="status">
              Transmission Sent. I will respond soon.
            </p>
          )}
        </form>
        <aside className="contact-panel glass-panel">
          <h3>Open channels</h3>
          <a href="mailto:arzu.edwin27@gmail.com"><FiMail /> Email</a>
          <a href="https://www.linkedin.com/in/edwin-arzu-9b02b016a/" target="_blank" rel="noreferrer"><FiLinkedin /> LinkedIn</a>
          <a href="https://github.com/Senqxi" target="_blank" rel="noreferrer"><FiGithub /> GitHub</a>
          <p>
            Based in Otsego County, NY. For IT support, cybersecurity, compliance, or systems roles, send the environment, problem, and expected outcome.
          </p>
        </aside>
      </div>
    </section>
  );
}

export default ContactTransmission;
